import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=63b52efa&scoped=true"
import script from "./AnimatedNumber.vue?vue&type=script&lang=ts"
export * from "./AnimatedNumber.vue?vue&type=script&lang=ts"
import style0 from "./AnimatedNumber.vue?vue&type=style&index=0&id=63b52efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b52efa",
  null
  
)

export default component.exports